(() => {
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-product-root]').forEach(root=>{
      if(root.dataset.bound)return;
      root.dataset.bound='true';
      const picker=root.querySelector('lumidog-variant-picker');
      const select=root.querySelector('[data-variant-select]');
      const image=root.querySelector('[data-product-image]');
      const zoom=root.querySelector('[data-image-zoom]');
      const dialog=root.querySelector('[data-image-dialog]');
      select?.addEventListener('change',()=>{
        if(picker?.ready)return;
        const option=select.selectedOptions[0];
        if(!option?.value)return;
        if(image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.imageAlt;}
        root.querySelector('[data-product-price]').textContent=option.dataset.price;
        const add=root.querySelector('[data-add-button]');
        add.disabled=option.dataset.available!=='true';
        add.textContent=add.disabled?root.dataset.soldOutLabel:root.dataset.addLabel;
        root.dispatchEvent(new CustomEvent('lumidog:variant-change'));
      });
      root.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
        if(!image)return;
        if(picker?.ready && button.dataset.galleryColor)picker.selectColor(button.dataset.galleryColor);
        image.removeAttribute('srcset');image.src=button.dataset.galleryImage;
        image.alt=button.dataset.galleryAlt || button.getAttribute('aria-label');
        if(zoom)zoom.href=image.src;
        root.querySelectorAll('[data-gallery-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
      }));
      zoom?.addEventListener('click',event=>{
        if(!dialog?.showModal || !image)return;
        event.preventDefault();
        const enlarged=dialog.querySelector('[data-zoom-image]');
        enlarged.src=image.src;enlarged.alt=image.alt;
        dialog.showModal();
      });
      dialog?.querySelector('[data-close-dialog]')?.addEventListener('click',()=>dialog.close());
      dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      const form=root.querySelector('.native-product-form');
      form?.addEventListener('submit',event=>{
        if(event.defaultPrevented)return;
        if(form.dataset.submitting){event.preventDefault();return;}
        form.dataset.submitting='true';form.setAttribute('aria-busy','true');
        root.querySelectorAll('[data-add-button],[data-sticky-add]').forEach(button=>{button.setAttribute('aria-disabled','true');button.textContent=root.dataset.addingLabel;});
      });
    });
    scope.querySelector('[data-contact-success]')?.focus();
  };
  window.addEventListener('pageshow',()=>document.querySelectorAll('.native-product-form[data-submitting]').forEach(form=>{
    delete form.dataset.submitting;form.removeAttribute('aria-busy');
    form.querySelector('lumidog-variant-picker')?.reflect();
    form.closest('[data-product-root]').querySelectorAll('[aria-disabled]').forEach(button=>button.removeAttribute('aria-disabled'));
  }));
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
